import { useFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/form/use-form-validation';
import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/patterns';
import { useMemo } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type EmailPasswordForm = {
  emailAddress: string;
  password: string;
};

export function useEmailPasswordFormValidation(): {
  emailAddress: RegisterOptions<EmailPasswordForm, 'emailAddress'>;
  password: RegisterOptions<EmailPasswordForm, 'password'>;
} {
  const { t } = useTranslation();

  const formValidationRules = useFormValidation();

  return useMemo(
    () => ({
      emailAddress: {
        ...formValidationRules.required({
          field: t('delmonicos-shared-sdk.inputs-auth-login.email-address'),
        }),
        ...formValidationRules.emailPattern({
          field: t('delmonicos-shared-sdk.inputs-auth-login.email-address'),
        }),
      },
      password: {
        ...formValidationRules.required({
          field: t('delmonicos-shared-sdk.inputs-auth-login.password'),
        }),
        ...formValidationRules.minLength({
          field: t('delmonicos-shared-sdk.inputs-auth-login.password'),
          value: PASSWORD_MIN_LENGTH,
        }),
        ...formValidationRules.maxLength({
          field: t('delmonicos-shared-sdk.inputs-auth-login.password'),
          value: PASSWORD_MAX_LENGTH,
        }),
      },
    }),
    [formValidationRules, t],
  );
}
